export default class Header {
  constructor({ text, type = 'h3', condition = true }) {
    this.component = type
    this.innerText = condition ? text : ''
  }
}
